<script>
    /* import { BrowserPrint } from "./bp";
    import { Zebra } from "./bpz"; */
    import { syncDelay } from "../script/common";
    import { Pinter } from "../script/store";
    import Select from "../leafElement/Select.svelte";

    let deviceDisplayedList = [];
    let used_device_wrap = null;
    let userSelectedDevice = null;

    initPrinterDevice();

    function initPrinterDevice() {
        deviceDisplayedList = [];
        disconnectDevice();

        // DEV
        /* const devPrintLst = [
            {
                name: "P1",
                id: 0,
            },
            {
                name: "P2",
                id: 1,
            },
        ];
        deviceDisplayedList = devPrintLst.map((device) => {
            return {
                id: device.uid,
                name: device.name,
                value: device,
            };
        }); */

        BrowserPrint.getDefaultDevice(
            "printer",
            (device) => {
                console.log("defaut device", device);
                used_device_wrap = generateDeviceWpar(device);
            },
            (err) => {
                console.log("WARN: not defaut printer found");
            }
        );
        //Discover any other devices available to the application
        BrowserPrint.getLocalDevices(
            (device_list) => {
                /* for (var i = 0; i < device_list.length; i++) {
                    //Add device to list of devices and to html select element
                    var device = device_list[i];
                    if (!selected_device || device.uid != selected_device.uid) {
                        devices.push(device);
                        var option = document.createElement("option");
                        option.text = device.name;
                        option.value = device.uid;
                    }
                } */
                console.log("[INFO - avalible printers]:", device_list);
                deviceDisplayedList = device_list.printer.map((device) => {
                    return {
                        id: device.uid,
                        name: device.name,
                        value: device,
                    };
                });
                if (deviceDisplayedList.length !== 0) {
                    userSelectedDevice = deviceDisplayedList[0].value;
                    selectPrinter(userSelectedDevice);
                }
            },
            (err) => {
                console.log("WARN: not printer found");
            }
        );
    }
    function setDevice(device) {
        used_device_wrap = generateDeviceWpar(device);
        Pinter.connect(used_device_wrap);
    }
    function disconnectDevice() {
        used_device_wrap = null;
        Pinter.connect(used_device_wrap);
    }
    function generateDeviceWpar(device) {
        // DEV
        /* const zDevice = {
            isPrinterReady() {
                return true;
            },
            send(str) {
                console.warn("MOCK printer msg", str);
            },
        }; */
        const zDevice = new Zebra.Printer(device);
        return {
            ref: device,
            name: device.name,
            send: async (str) => {
                let tryCount = 5;
                while (tryCount > 0) {
                    tryCount--;
                    console.log("Triing send", tryCount);
                    try {
                        const statusResponse = await zDevice.isPrinterReady();
                        if (statusResponse !== "Ready") {
                            throw new Error("Device not ready");
                        }
                        await zDevice.send(str);
                        break;
                    } catch (err) {
                        console.log("Can not send");
                    }
                    await syncDelay(1000);
                }
            },
        };
    }
    function selectPrinter() {
        console.log("Device Selected:", userSelectedDevice);
        setDevice(userSelectedDevice);
    }
    function testPrint() {
        console.log("selected", used_device_wrap);
        if (used_device_wrap) {
            used_device_wrap.send("^XA^FO200,200^A0N36,36^FDTest Label^FS^XZ");
        }
    }

    window.DEV_testPrint = testPrint;

</script>

<div class="root">
    {#if deviceDisplayedList.length === 0}
        <p class="notFound">
            Tiskárna nepřipojena. Zkontrolujte, zda běží aplikace <strong
                >Browser Print</strong
            >.
        </p>
        <p class="notFound" style="padding-top: 0;">
            Více informací naleznete v záložce <strong>Pomocník</strong><!-- <a>Pomocník</a> -->
        </p>
        <!-- TODO LINK -->
        <button class="standartButton" on:click={initPrinterDevice}>
            Znovu načíst dostupné tiskárny
        </button>
    {:else}
        <!--  {#if used_device_wrap}
            <div class="borderBox">
                <p class="connectedTitle">Připojeno k:</p>
                <p class="connectedVal">{disconnectDevice}</p>
            </div>
            <button class="standartButton" on:click={initPrinterDevice}>
                Odpojit
            </button>
        {/if} -->
        <div class="select">
            <Select
                nullAvalible={true}
                optionsList={deviceDisplayedList}
                bind:userSelected={userSelectedDevice}
            />
            <div
                class="activeIcon inactiveIconPlus customIcon"
                on:click={initPrinterDevice}
            >
                <span class="material-icons"> refresh </span>
            </div>
        </div>
        <button
            class="standartButton"
            disabled={!userSelectedDevice}
            on:click={selectPrinter}
        >
            Připoj tiskárnu
        </button>
        <!-- <button class="standartButton" on:click={initPrinterDevice}>
            Znovu načíst dosputné tiskárny
        </button> -->
        <!-- <button disabled={!used_device_wrap} class="standartButton" on:click={testPrint}>
            DEV test print
        </button> -->
    {/if}
</div>

<style>
    .select {
        padding: 1.5rem;
        display: flex;
        align-items: center;
    }
    .customIcon {
        margin-left: 5px;
    }
    .notFound {
        padding: 1rem 2rem;
    }
</style>
